import TabBar from "@/components/TabBar";
import styles from "@/styles/productDetail/paymentNotice.module.scss";
import { useEffect, useState } from "react";
import PayPalSvg from "@/svgs/pay/icon-payment-logo-paypal.svg";
import VisaSvg from "@/svgs/pay/icon-payment-logo-visa.svg";
import MasterSvg from "@/svgs/pay/icon-payment-logo-master.svg";
import BpaySvg from "@/svgs/pay/icon-payment-logo-bpay.svg";
import AMEXSvg from "@/svgs/pay/icon-payment-logo-amex.svg";
import ZipSvg from "@/svgs/pay/icon-payment-logo-zip.svg";
import AfterpaySvg from "@/svgs/pay/icon-payment-logo-afterpay.svg";
import { Button } from "antd";

export default function PaymentNotice(props: any) {
  const defaultTabList = [
    { id: 3, name: "Warranty" },
    { id: 2, name: "Delivery" },
    { id: 1, name: "Payment Option" },
  ];
  const [tabList, setTabList] = useState(defaultTabList);
  const [activeTab, setActiveTab] = useState(0);
  const [recordId, setRecordId] = useState<string | number>("");
  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };
  const recordIdChange = (id: number | string) => {
    setRecordId(id);
  };

  useEffect(() => {
    if (!props.warrantyHtml) {
      setTabList([
        { id: 2, name: "Delivery" },
        { id: 1, name: "Payment Option" },
      ]);
      setRecordId(2);
    } else {
      setTabList(defaultTabList);
      setRecordId(3);
    }
  }, [props.warrantyHtml]);

  return (
    <div className={styles["paymentNotice"]} id="paymentNotice">
      <TabBar
        tabList={tabList}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        recordId={recordIdChange}
      />

      {recordId === 3 && (
        <div
          className={styles["warranty-box"]}
          dangerouslySetInnerHTML={{ __html: props.warrantyHtml }}
        ></div>
      )}

      {recordId === 2 && (
        <div className={styles["delivery-box"]}>
          <h4>All items are sent via Australia Post or another courier.</h4>
          <ul>
            <li>
              Once items are sent, delivery times may vary according to
              Australia Post or courier&apos;s delivery schedule.
            </li>
            <li>
              Most items are dispatched within 24 hours of payment clearance
              (BPAY may take longer).
            </li>
            <li>Transit insurance is used to cover all products.</li>
          </ul>
          <div>
            <Button
              type="link"
              href="/legal/delivery-brand"
              style={{ paddingLeft: "0" }}
            >
              How to Track Your Order?
            </Button>
          </div>
        </div>
      )}

      {
        !!(recordId === 1)
        &&
        (
          <div className={styles["payment-box"]}>
            <div className={styles["introduce"]}>
              <p className={styles["line"]}>
                Crazysales accepts a range of payment options including
                PayPal,BPAY, Visa, Mastercard.
              </p>
              <p className={styles["line"]}>
                Rest assured as all payments are processed using the latest SSL
                encryption technology!
              </p>
              <div className={styles["payment-list"]}>
                <div className={styles["paymentItem"]}>
                  <PayPalSvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <VisaSvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <MasterSvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <BpaySvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <AMEXSvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <ZipSvg />
                </div>
                <div className={styles["paymentItem"]}>
                  <AfterpaySvg />
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}
